import { getReadableColor } from "../../helpers";
var links = {
  mainMenu: {
    color: function color(theme) {
      return getReadableColor(theme, "background");
    },
    display: "block",
    fontSize: 3,
    position: "relative",
    textDecoration: "none",
    "&:after": {
      content: '""',
      borderBottomStyle: "solid",
      borderBottomWidth: "medium",
      borderBottomColor: "secondary",
      display: "none",
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0
    },
    ":hover, :focus, :active, &.active": {
      textDecoration: "none",
      "&:after": {
        display: "block"
      }
    }
  }
};
export default links;